export function isAlphabetic(text: string): boolean {
	return /^[a-zA-Z ]*$/g.test(text);
}
